<template>
  <div v-loading="loading" class="edit" element-loading-text="数据获取中">
    <div class="editContent">
      <div class="MQcut">
        <div v-if="!!qmData.autoScreenshotMd5" class="uploadpic">
          <img :src="questionImgListUrl(qmData.autoScreenshotMd5)" alt="截图">
        </div>
        <div v-for="(item,index) in base64List" :key="index" class="uploadpic canEdit" @mouseenter="mouseenter(index)"
          @mouseleave="mouseleave(index)">
          <img :src="item.url" alt="截图" @click="startKss(index,$event)">
          <div v-if="showDelete && item.hasKss && imageIndex == index" class="delete" @click="deleteImage(index)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
      </div>
      <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="90px" size="small"
        class="formStyle">
        <el-form-item label="问题描述:" prop="checkContent">
          <el-input v-model="addForm.checkContent" type="textarea" rows="4" maxlength="200" show-word-limit
            style="max-height:490px" placeholder="请填写问题描述"></el-input>
        </el-form-item>
        <el-form-item label="审图要点:" class="itemStyle">
          <template #label>
            <div class="labelStyle">
              <span>审图要点:</span>
              <el-button class="rcStyle" type="primary" plain size="small" @click="showImgPoint">关联审图要点</el-button>
            </div>
          </template>
          <el-input v-model="addForm.drawingReviewPoints" style="margin-left:0" type="textarea" readonly></el-input>
        </el-form-item>
        <el-form-item label="关联文件:" class="associatedFileStyle">
          <template #label>
            <div class="labelStyle">
              <span>关联文件:</span>
              <el-button class="rcStyle" type="primary" plain size="small" @click="showAssociatedFile">关联文档目录树 </el-button>
              <el-button class="rcStyle" type="primary" plain size="small" @click="uploadFiles">本地上传</el-button>
            </div>
          </template>
          <ul>
            <li v-for="(item,index) in floderData" :key="index">
              <p class="fileNamestyle" :title="item.fileName">{{ item.fileName }}</p>
              <p style="margin-top:3px">
                <img :src="down" alt="下载" style="margin-right: 8px" @click="todown(item)">
                <img :src="del" alt="删除" style="margin-right: 5px" @click="todel(index)">
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item key="qmTypeId" label="问题类型:" prop="qmTypeId">
          <el-select  v-model="addForm.qmTypeId">
            <el-option v-for="item in dicList.checkTypeList" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item key="problemTypeId" label="严重等级:" prop="problemTypeId">
          <el-radio-group v-model="addForm.problemTypeId" size="small">
            <el-radio v-for="item in dicList.severityLevelList" :key="item.id" :label="item.id">{{ item.cnName }} </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item v-if="stageNameBoolean" label="阶 段:">
          <div v-if="stageName">{{ stageName }}</div>
          <el-select v-else v-model="addForm.stageId" placeholder="请选择阶段">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name=='阶段').optionalValues" :key="item.id"
              :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="childNameBoolean" label="子 项:">
          <!-- <div v-if="childName">{{ childName }}</div> -->
          <el-select v-model="addForm.stageChildId" placeholder="请选择子项" clearable>
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '子项').optionalValues"
              :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item v-if="specNameBoolean" label="专 业:">
          <div v-if="specName">{{ specName }}</div>
          <el-select v-else v-model="addForm.specId" placeholder="请选择专业" @change="addForm.multiSpecListspecIds=[]">
            <el-option v-for="item in dicList.specStageChildVos.find(ele=>ele.name == '专业').optionalValues"
              :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="专 业:" prop="multiSpecListspecIds">
          <el-select
            v-model="addForm.multiSpecListspecIds"
            placeholder="请选择专业"
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="item in multiSpecList"
              :key="item.id"
              :label="item.cnName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="修改方:" prop="modifierIds">
          <!-- <el-select v-model="addForm.modifierIds" multiple filterable placeholder="指定修改人">
            <el-option v-for="item in dicList.modifierList" :key="item.userId" :label="item.name" :value="item.userId">
            </el-option>
          </el-select> -->
          <el-select
            v-model="addForm.modifierIds"
            filterable
            placeholder="指定修改方"
            clearable
          >
            <el-option-group
            v-for="group in dicList.modifierList"
            :key="group.label"
            :label="group.label"
            >
              <el-option v-for="item in group.options" :key="item.id" :label="item.cnName" :value="item.id" ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="位置:" prop="textProperties">
          <el-input v-model="addForm.textProperties" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="small" @click="closeModelq(true)">取 消</el-button>
      <el-button v-loading="addLoading" size="small" title="确认修改" type="primary" @click="addnotations">修改</el-button>
    </div>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile" :prj-id="prjID" />
    <uploader ref="uploader" type-key="1" @fileAdded="fileAdded" />
  </div>
</template>

<script>
const addParamsForm = () => ({
  checkContent: "", // 问题描述
  drawingReviewPoints: "", // 审图要点
  qmTypeId: "", // 意见类型
  problemTypeId: "", // 严重等级
  stageId: "", // 阶段
  specId: "", // 专业
  multiSpecListspecIds: [], // 跨专业
  stageChildId: "", // 子项
  modifierId: "", // 修改人
  textProperties:''
});
import { mapState } from "vuex";
import iconImage from "../images/icon-cutImg.png";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import { questionImgUrlNew, downloadUrltoken } from "@/CommonDP/mongeView/utils";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import uploader from "@/CommonDP/components/UploaderForPerFileDan/Uploader.vue";
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
import globalParams from "@/CommonDP/utils/globalParams";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import question from "@/xgzdService/question-service"
import notationService from "@/commonService/file-service";
export default {
  components: { checkImgPoint, associatedFile, uploader },
  props: {
    questionId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dicList: [],
      prjID: "",
      fileId: "",
      loading: false,
      qmData: {},
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      stageName: "",
      stageNameBoolean: false,
      specName: "",
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: "",
      childNameBoolean: false,

      imageIndex: "",
      showDelete: false,
      imgPoint: false,
      addForm: addParamsForm(),
      rules: {
        // problemTypeId: [{ required: true, message: "严重等级不可为空", trigger: "change" }],
        checkContent: [{ required: true, message: "问题描述不可为空", trigger: "blur" }],
        // qmTypeId: [{ required: true, message: "意见类型不可为空", trigger: "change" }],
        modifierIds: [{ required: false, message: "请选择修改方", trigger: "change" }]
      },
      addLoading: false,
      picList: [],
      associatedFileShow: false,
      floderData: [],
      down: require("./../images/issueMgDown.png"),
      del: require("./../images/issueMgDel.png"),
      shareId: "",
      sharerUserId: "",
      flowInstanceId: ""
    };
  },
  computed: {
    ...mapState({
      // dwgdata: state => state.monge.dwgdata,
      // spaceOfDwgData:state => state.monge.spaceOfDwgData,
      // modeldata: state => state.monge.modeldata,
      floderObj: (state) => state.uploaderAnnotation.floderObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    dwgdata() {
      // 图纸信息
      return JSON.parse(mongeApp.map.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    modelInfoData() {
      // 模型信息
      return JSON.parse(mongeApp.model.fileInfo);
    },
    docmentData() {
      // 文件信息（非引擎）
      return JSON.parse(mongeApp.other.fileInfo);
    },
    editParams() {
      const { checkContent, drawingReviewPoints, qmTypeId, problemTypeId, modifierIds, stageId, specId, multiSpecListspecIds, stageChildId,textProperties } = this.addForm;
      const source = "WEB端";
      const qmType = !!this.dicList.checkTypeList && this.dicList.checkTypeList.length ? this.dicList.checkTypeList.find((item) => item.id === qmTypeId).cnName : "";
      const problemType =
        !!this.dicList.severityLevelList && this.dicList.severityLevelList.length ? this.dicList.severityLevelList.find((item) => item.id === problemTypeId).cnName : "";
      // const modifierName = !!this.dicList.modifierList && this.dicList.modifierList.length ? this.dicList.modifierList.find(item => item.userId === modifierId).name : "";
      const modifierList = []; // 修改人多选
      if (modifierIds) {
        let list = [...this.dicList.modifierList[0].options, ...this.dicList.modifierList[1].options]
          let selectItem = list.find(sor=>sor.id == modifierIds)
          let obj={modifierId:modifierIds, modifierName:selectItem.cnName, type:selectItem.remark };
          modifierList.push(obj);
      }
      const multiSpecList = [];
      // const muspecList = this.dicList.specStageChildVos.find((sor) => sor.name === "跨专业").optionalValues;
      if (multiSpecListspecIds.length) {
        multiSpecListspecIds.forEach((ele) => {
          let obj = {
            specId: ele,
            specName: this.dicList.specList.find((sor) => sor.id == ele).cnName,
          };
          multiSpecList.push(obj);
        });
      }
      let stageName = "";
      // if (!this.isHky) {
      //   stageName = stageId ? this.dicList.specStageChildVos.find((ele) => ele.name === "阶段").optionalValues.find((item) => item.id === stageId).cnName : "";
      // } else {
      //   stageName = this.stageName;
      // }
      let specName = "";
      // if (!this.isHky) {
      //   specName = specId ? this.dicList.specStageChildVos.find((ele) => ele.name === "专业").optionalValues.find((item) => item.id === specId).cnName : "";
      // } else {
      //   specName = this.specName;
      // }
      let stageChildName = "";
      // if (!this.isHky) {
      //   stageChildName = stageChildId ? this.dicList.specStageChildVos.find((ele) => ele.name === "子项").optionalValues.find((item) => item.id === stageChildId).cnName : "";
      // } else {
      //   stageChildName = this.childName;
      // }
      let layoutName = "";
      if (this.type === "dwg") {
        layoutName = JSON.parse(this.spaceOfDwgData);
      }
      const annexFileList = [];
      if (!!this.floderData && this.floderData.length) {
        this.floderData.forEach((ele) => {
          const obj = { fileId: ele.fileId, fileName: ele.fileName, id: "", uploadType: ele.uploadType };
          annexFileList.push(obj);
        });
      }
      let newcoordinatedata = "";
      if (this.qmData.coordinate) {
        const newcoordinate = JSON.parse(this.qmData.coordinate);
        if (newcoordinate.stMarkNewInfo) {
          newcoordinate.stMarkNewInfo.strText = checkContent;
        }
        newcoordinatedata = JSON.stringify(newcoordinate);
      }
      const params = {
        textProperties,
        questionId: this.questionId,
        prjId: this.prjID,
        fileList: this.fileList,
        checkContent,
        qmTypeId,
        qmType,
        problemTypeId,
        problemType,
        coordinate: newcoordinatedata,
        // modifierId,
        // modifierName,
        modifierList,
        drawingReviewPoints,
        source,
        multiSpecList,
        stageId,
        stageName,
        specId,
        specName,
        stageChildId,
        stageChildName,
        layoutName, // 布局空间,
        picMd5List: this.picList,
        autoScreenshotMd5: this.qmData.autoScreenshotMd5,
        autoScreenshotFileId: this.qmData.autoScreenshotFileId,
        autoScreenshotFileVersion: this.qmData.autoScreenshotFileVersion,
        sectionPos: this.qmData.sectionPos,
        // coordinate: this.qmData.coordinate,
        annexFileList,
        userId: this.sharerUserId,
        flowInstanceId: this.flowInstanceId,
        shareId: this.shareId
      };
      return params;
    },
    multiSpecList() {
      if (
        this.dicList.specList &&
        this.dicList.specList.length > 0 &&
        this.addForm.specId
      )
      return this.dicList.specList
    },
  },
  mounted() {
    this.isHky = globalParams.get("isHky");
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      this.sharerUserId = this.$route.query.sharerId || "";
      this.flowInstanceId = this.$route.query.flowInstanceId || "";
      this.shareId = this.$route.query.i || "";
      if (this.type === "dwg") {
        this.prjID = this.dwgdata.prjId;
        this.fileId = this.dwgdata.fileId;
      } else if (this.type === "model") {
        if (this.modelInfoData.fileObj) {
          this.fileId = "";
          this.prjID = this.modelInfoData.prjId;
        } else {
          this.fileId = this.modelInfoData.fileId;
          this.prjID = this.modelInfoData.prjId;
        }
      } else {
        this.fileId = this.docmentData.fileId;
        this.prjID = this.docmentData.prjId;
      }
      await this.queryDic();
      await this.getDetailList();
    },
    async queryDic() {
      const res = await question.getNotationDic(this.prjID, this.fileId, this.sharerUserId);
      
        this.dicList = res.data || {};
      let roleList = { label: '角色', options: res.data.roleList };
      let userList = { label: '用户', options: res.data.userList };
      this.dicList.modifierList = [roleList, userList]
    },
    async getDetailList() {
      try {
        const res = await mongeService.getDrawingQuestionDetails(this.questionId, this.sharerUserId, this.flowInstanceId, this.shareId);
        this.qmData = res.data;
        this.floderData = [];
        if (!!res.data.annexFileList && res.data.annexFileList.length) {
          this.floderData = res.data.annexFileList;
        }
        this.addForm.checkContent = this.qmData.checkContent;
        this.addForm.drawingReviewPoints = this.qmData.drawingReviewPoints;
        this.addForm.qmTypeId = this.qmData.qmTypeId;
        // this.addForm.stageChildId = this.qmData;
        this.addForm.problemTypeId = this.qmData.problemTypeId;
        this.addForm.specId = this.qmData.specId;
        let ids = '';
        
        this.qmData.modifierList.forEach((ele) => {
          ids = ele.modifierId
        });
        this.addForm.modifierIds = ids;
        if (this.qmData.multiSpecList) {
          let list = this.dicList.specList
          let ids = [];
          this.qmData.multiSpecList.forEach((item) => {
            let idobj = list.find((ele) => ele.cnName == item.specName);
            let id = idobj.id;
            ids.push(id);
          });
          console.log(ids);
          this.addForm.multiSpecListspecIds = ids;
        }

        if (this.qmData.screenshotFileList) {
          this.base64List.forEach(async (ele, index) => {
            if (this.qmData.screenshotFileList[index]) {
              let { fileMd5, fileId, fileVersion } = this.qmData.screenshotFileList[index] || {};
              ele.url = await this.toBase64(questionImgUrlNew(fileMd5, fileId, fileVersion));
              ele.hasKss = true;
            } else {
              ele.url = iconImage;
              ele.hasKss = false;
            }
          });
        }
        if (this.dicList.specStageChildVos && this.dicList.specStageChildVos.some((ele) => ele.name === "阶段")) {
          // if(this.dicList.specStageChildVos.find(ele=>ele.name=='阶段').defaultValue){
          //   this.stageName = this.qmData.specStageChildVos.find(ele=>ele.name=='阶段').value ;
          //   this.stageNameBoolean = true
          // }else{
          if (!this.isHky) {
            this.stageName = "";
          } else {
            this.stageName = this.qmData.specStageChildVos.find((ele) => ele.name === "阶段").value;
            this.addForm.stageId = this.qmData.stageId;
          }
          this.stageNameBoolean = true;
          // }
        } else {
          this.stageName = "";
          this.stageNameBoolean = false;
        }

        if (this.dicList.specStageChildVos && this.dicList.specStageChildVos.some((ele) => ele.name === "专业")) {
          // if(this.dicList.specStageChildVos.find(ele=>ele.name=='专业').defaultValue){
          //   this.specName = this.qmData.specStageChildVos.find(ele=>ele.name=='专业').value;
          //   this.specNameBoolean = true
          // }else{
          if (!this.isHky) {
            this.specName = "";
          } else {
            this.specName = this.qmData.specStageChildVos.find((ele) => ele.name === "专业").value;
            this.addForm.specId = this.qmData.specId;
          }
          this.specNameBoolean = true;
          // }
        } else {
          this.specName = "";
          this.specNameBoolean = false;
        }

        if (this.dicList.specStageChildVos && this.dicList.specStageChildVos.some((ele) => ele.name === "跨专业")) {
          // if(this.dicList.specStageChildVos.find(ele=>ele.name=='跨专业').defaultValue){
          //   this.multiSpecName = this.qmData.specStageChildVos.find(ele=>ele.name=='跨专业').value
          //   this.multiSpecNameBoolean = true
          // }else{
          this.multiSpecName = "";
          this.multiSpecNameBoolean = true;
          // }
        } else {
          this.multiSpecName = "";
          this.multiSpecNameBoolean = false;
        }

        if (this.dicList.specStageChildVos && this.dicList.specStageChildVos.some((ele) => ele.name === "子项")) {
          // if(this.dicList.specStageChildVos.find(ele=>ele.name=='子项').defaultValue){
          //   this.childName = this.qmData.specStageChildVos.find(ele=>ele.name=='子项').value ;
          //   this.childNameBoolean = true
          // }else{
          this.childName = this.qmData.specStageChildVos.find((ele) => ele.name === "子项").value;
          this.addForm.stageChildId = this.qmData.stageChildId;
          this.childNameBoolean = true;
          // }
        } else {
          this.childName = "";
          this.childNameBoolean = false;
        }
        // 有阶段
        if (this.stageNameBoolean && !this.stageName) {
          const name = this.qmData.specStageChildVos.find((ele) => ele.name === "阶段").value;
          const list = this.dicList.specStageChildVos.find((ele) => ele.name === "阶段").optionalValues;
          this.addForm.stageId = list.find((ele) => ele.cnName === name).id;
        }
        // 有专业
        if (this.specNameBoolean && !this.specName) {
          const name = this.qmData.specStageChildVos.find((ele) => ele.name === "专业").value;
          const list = this.dicList.specStageChildVos.find((ele) => ele.name === "专业").optionalValues;
          this.addForm.specId = list.find((ele) => ele.cnName === name).id;
        }
        // 跨专业
        if (this.multiSpecNameBoolean && !this.multiSpecName) {
          const nameArray = this.qmData.specStageChildVos.find((ele) => ele.name === "跨专业").value.split(",");
          const list = this.dicList.specStageChildVos.find((ele) => ele.name === "跨专业").optionalValues;
          const ids = [];
          nameArray.forEach((name) => {
            const id = list.find((ele) => ele.cnName === name).id;
            ids.push(id);
          });
          // this.addForm.multiSpecListspecIds = ids;
        }
        // 有子项
        if (this.childNameBoolean && !this.childName) {
          const name = this.qmData.specStageChildVos.find((ele) => ele.name === "子项").value;
          const list = this.dicList.specStageChildVos.find((ele) => ele.name === "子项").optionalValues;
          this.addForm.stageChildId = list.find((ele) => ele.cnName === name).id;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error)
      }
    },
    fileAdded(val) {
      if (!val.fileId) {
        this.floderData = [];
      }
      val.uploadType = 2;
      this.floderData.push(val);
    },
    // 取消修改
    closeModelq() {
      this.$emit("openList");
    },
    // 确认修改
    addnotations() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.addLoading = true;
          this.picList = [];
          for (const index in this.base64List) {
            if (this.base64List[index].hasKss) {
              this.picList.push(await this.getFileMD5(this.base64List[index].url));
            }
          }
          let editParams = {...this.editParams};
          let section = localStorage.getItem('setSection'); // 剖切
          if(section){
            let type = JSON.parse(section)?.query;
            let allowTypes = ['x', 'y', 'z'];
            if(allowTypes.includes(type)) {
              let height = mongeApiMlib.getSectionPos(type);
              const sectionPos = {type, height};
              editParams.sectionPos = sectionPos;
            }
            if(type==='box'){
              let box = mongeApiMlib.getSectionPos(type);
              const sectionPos = {type, box};
              editParams.sectionPos = sectionPos;
            }
          }
          try {
            await notationService.notationEdit(editParams);
            this.$message.success("编辑成功");
            this.base64List.forEach((ele) => {
              ele.url = this.iconImage;
              ele.hasKss = false;
            });
            this.addForm = addParamsForm();
            this.addLoading = false;
            mongeMutations.changeRefreshKey();
            this.$emit("openList");
          } catch (error) {
            this.addLoading = false;
          }
        }
      });
    },
    toBase64(imgUrl) {
      // 一定要设置为let，不然图片不显示
      const image = new Image();
      // 解决跨域问题
      image.setAttribute("crossOrigin", "anonymous");
      const imageUrl = imgUrl;
      image.src = imageUrl;
      return new Promise((res) => {
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const quality = 0.8;
          const dataurl = canvas.toDataURL("image/jpeg", quality);
          res(dataurl);
        };
      });
      // image.onload为异步加载
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picUploadNew(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },
    deleteImage(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    mouseenter(index) {
      this.imageIndex = index;
      this.showDelete = true;
    },
    mouseleave(index) {
      this.imageIndex = index;
      this.showDelete = false;
    },
    startKss(index) {
      this.$emit("startKss", {
        callback: (data) => {
          this.getAddCutPicList(data, index);
        }
      });
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    questionImgListUrl(fileMD5) {
      let { autoScreenshotFileId, autoScreenshotFileVersion } = this.qmData || {};
      if (!fileMD5) {
        return;
      }
      return questionImgUrlNew(fileMD5, autoScreenshotFileId, autoScreenshotFileVersion);
    },
    showImgPoint() {
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.addForm.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile() {
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val) {
      this.associatedFileShow = false;
      const arr1 = val;
      const arr2 = this.floderData;
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [...arr1, ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))];
      const isnotfloderData = [...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))];
      this.floderData = isfloderData;
      for (const key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(`文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        }, 10);
      }
    },
    // 本地上传
    uploadFiles() {
      const params = {
        prjId: this.prjID,
        folderId: "",
        versionId: ""
      };
      this.$refs.uploader.openUploader(params);
      // this.$store.dispatch("annotationUploadFloderData", this.floderData);
      // this.$store.dispatch("annotationUploadType", new Date().getTime());
    },
    todown(row) {
      const prjId = this.$route.query.prjId || this.prjID;
      const fileId = row.fileId;
      window.location = downloadUrltoken(prjId, fileId, this.sharerUserId);
    },
    todel(index) {
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    },
    async changeMultiSpecListspecIds(val) {
      if (this.$custom === "QHY") {
        const prjId = this.$route.query.prjId || this.prjID;
        const enterpriseId = this.$route.query.enterpriseId || this.enterpriseId;
        const data = {
          enterpriseId,
          prjId,
          specIds: val
        };
        const multiDisciplinary = [];
        const res = await mongeService.prjPersonPlanQueryUserListRole(data);
        res.data.forEach((ele) => {
          multiDisciplinary.push(ele.userId);
        });
        const arr = this.addForm.modifierIds.concat(multiDisciplinary);
        const resc = new Map();
        this.addForm.modifierIds = arr.filter((a) => !resc.has(a) && resc.set(a, 1));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit {
  width: 100%;
  height: 100%;
  padding: 10px 0 10px 10px;
  .editContent {
    width: 100%;
    height: calc(100% - 50px);
    padding-right: 10px;
    overflow-y: auto;
    .formStyle {
      padding-top: 10px;
    }
    .itemStyle {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
        display: flex;
      }
      /deep/.el-form-item__content {
        margin-top: 30px;
      }
    }
    .associatedFileStyle {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
        display: flex;
      }
      /deep/.el-form-item__content {
        margin-top: 30px;
      }
      li {
        display: flex;
        justify-content: space-between;
        color: var(--theme-color);
        cursor: pointer;
        border: 1px solid #ffffff00;
        .fileNamestyle {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 200px;
          padding-left: 5px;
        }
      }
      li:hover {
        background: #eef1ff;
      }
    }
    .labelStyle {
      font-size: 14px;
      line-height: 28px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      margin-left: 20px;
      > span {
        font-size: 14px;
        line-height: 28px;
        margin-right: 10px;
      }
    }
    /deep/.el-radio {
      margin-right: 8px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    .el-button {
      margin: 0 20px;
    }
  }
  .MQcut {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    .uploadpic {
      width: 75px;
      height: 75px;
      margin-right: 5px;
      position: relative;
      img {
        width: 75px;
        height: 75px;
      }
      .delete {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        z-index: 1px;
        cursor: pointer;
        i {
          font-size: 20px;
          color: #fff;
        }
      }
    }
    .canEdit {
      cursor: pointer;
    }
  }
}
</style>
